module.exports = __webpack_public_path__ + "img/pos_tag_400.8924ec19.png";